import { Box, Typography } from "@mui/material";
import LoadingIcon from "../../../../components/LoadingIcon";
import Guideline from "../components/Guideline";
import GuidelineStep from "../components/GuidelineStep";
import GuidelineStepByStep from "../components/GuidelineStepByStep";

import { Fragment, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import useAPI from "../../../../api/hooks/useAPI";
import useIsIntegrated from "../../../../api/hooks/useIsIntegrated";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";
import { logos } from "../../environment/icons/iconExport";
import IntegrationGuideAlert from "../components/IntegrationGuideAlert";

const ZoomIntegration = () => {
  const { isIntegrated, isIntegratedLoading } = useIsIntegrated("zoom");
  const [loading, setLoading] = useState(false);
  const [authUrl, setAuthUrl] = useState("");
  const [searchParams] = useSearchParams();
  const [guideMode, setGuideMode] = useState(false);

  useEffect(() => {
    if (searchParams.has("viewonly")) {
      setGuideMode(true);
    }
  }, [searchParams]);

  const { fetchZoomAuthUrl } = useAPI();

  useEffect(() => {
    if (!isIntegrated) {
      setLoading(true);
      fetchZoomAuthUrl().then((response) => {
        setAuthUrl(response.data.url);
        setLoading(false);
      });
    }
  }, [isIntegrated]);

  if (loading || isIntegratedLoading) {
    return <LoadingIcon />;
  }

  return (
    <Box>
      <Guideline
        title={
          !isIntegrated
            ? "Once integrated, Breeze will scan your Zoom for misconfigurations and vulnerabilities."
            : ""
        }
        image={logos.ZoomLogo}
        name={"Zoom"}
        content={
          loading || isIntegratedLoading ? (
            <LoadingIcon size={25} />
          ) : isIntegrated && !guideMode ? (
            <Fragment>
              <Typography variant={"h4"}>Zoom is integrated!</Typography>
            </Fragment>
          ) : (
            <>
              <Box
                sx={{
                  mb: 2,
                }}
              >
                {guideMode && <IntegrationGuideAlert />}
              </Box>

              {/* SETUP INSTRUCTIONS */}
              <Typography variant="h4" mb="15px">
                Quick Authorization Flow
              </Typography>
              <GuidelineStepByStep>
                <GuidelineStep title="Authorize Breeze app to Zoom">
                  {authUrl && (
                    <PrimaryButton
                      sx={{
                        width: "150px",
                      }}
                      onClick={() => window.open(authUrl, "_blank")}
                      disabled={guideMode}
                    >
                      Authorize
                    </PrimaryButton>
                  )}
                </GuidelineStep>
              </GuidelineStepByStep>
            </>
          )
        }
      />
    </Box>
  );
};

export default ZoomIntegration;
